module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Dedication-rw",
    attrs: {
      "epub:type": "frontmatter dedication",
      "id": "Dedication1"
    }
  }, [_c('div', {
    staticClass: "block-rw dedication-rw",
    attrs: {
      "id": "dedication1"
    }
  }, [_c('p', {
    staticClass: "ded-rw",
    attrs: {
      "id": "p50"
    }
  }, [_c('span', [_vm._v("Dedicated to"), _c('br'), _vm._v("\nSarah Younger,"), _c('br'), _vm._v("\nfor urging me to write about the Carlisles")])]), _vm._v(" "), _c('p', {
    staticClass: "ded-rw",
    attrs: {
      "id": "p3163"
    }
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "ded-rw",
    attrs: {
      "id": "p51"
    }
  }, [_c('span', [_vm._v("And to my father,"), _c('br'), _vm._v("\nwho never once threatened"), _c('br'), _vm._v("\nto send me away to school or to a convent"), _c('br'), _vm._v("\n(although perhaps he wishes he had)")])]), _vm._v(" "), _c('p', {
    staticClass: "ded-rw",
    attrs: {
      "id": "p3164"
    }
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "ded-rw",
    attrs: {
      "id": "p52"
    }
  }, [_c('span', [_vm._v("Special thanks to"), _c('br'), _vm._v("\nMichele Bidelspach, Jordan Rubinstein, and Angelina Krahn"), _c('br'), _vm._v("\nfor all your help"), _c('br'), _vm._v("\nin writing and releasing this book")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703b5f67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s004-Dedication-01.vue
// module id = 69
// module chunks = 0